export default __webpack_public_path__ + "static/media/Segregação Cargas Perigosas.700b5911.pdf";